"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePicker = void 0;

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _nl = _interopRequireDefault(require("date-fns/locale/nl"));

var _de = _interopRequireDefault(require("date-fns/locale/de"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _pickers = require("@material-ui/pickers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("../../atoms/TextField"));

var _styles = _interopRequireDefault(require("./styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var langMap = {
  en: _enUS["default"],
  nl: _nl["default"],
  de: _de["default"]
};

var DatePicker = function DatePicker(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      onChange = _ref.onChange,
      onError = _ref.onError,
      lang = _ref.lang,
      props = _objectWithoutProperties(_ref, ["classes", "onChange", "onError", "lang"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      setSelectedDate = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFilled = _useState4[0],
      setIsFilled = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var handleDateChange = (0, _react.useCallback)(function (date, value) {
    // if it finds mark characters, it's not filled yet
    var maskCharFound = Boolean(/_/.exec(value)); // update state to control error display

    setIsFilled(!maskCharFound);
    setSelectedDate(date);
    onChange && onChange(date);
  }, [onChange]);
  var handleError = (0, _react.useCallback)(function (error, value) {
    isFilled ? setError(error) : setError(null);
    onError && onError(error, value);
  }, [isFilled, setError, onError]);
  return _react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns["default"],
    locale: langMap[lang]
  }, _react["default"].createElement(_pickers.KeyboardDatePicker, _extends({}, props, {
    error: isFilled && Boolean(error),
    helperText: isFilled && error,
    onError: handleError,
    onChange: handleDateChange,
    value: selectedDate,
    TextFieldComponent: _TextField["default"],
    PopoverProps: {
      className: classes.popover
    }
  })));
};

exports.DatePicker = DatePicker;
DatePicker.defaultProps = {
  disableToolbar: true,
  autoOk: true,
  variant: 'inline',
  onChange: function onChange() {},
  onError: function onError() {},
  format: 'dd-MM-yyyy',
  placeholder: 'DD-MM-YYYY',
  lang: 'en'
};
DatePicker.propTypes = {
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  lang: _propTypes["default"].oneOf(['en', 'nl', 'de'])
};

var _default = (0, _styles["default"])(DatePicker);

exports["default"] = _default;